var _path, _mask;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.969 18L66 25.031l-30 30-30-30L13.031 18 36 40.969 58.969 18z",
    fill: "#333"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "chevron-down_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 18,
    width: 60,
    height: 38
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.969 18L66 25.031l-30 30-30-30L13.031 18 36 40.969 58.969 18z",
    fill: "#fff"
  }))));
}
export default SvgChevronDown;